import type { AppUrlContext, ProjectUrlAdapter } from '@cognite/e2e-auth';

import {
  buildAppPath,
  getOrgSwitchOrigin,
  normalizePathname,
  parseAppPathFromPathname,
} from './project-path';

type LocationAdapter = Pick<Location, 'pathname' | 'href' | 'hostname'> & {
  assign: Location['assign'];
};

export const createInfieldProjectUrlAdapter = (
  location: LocationAdapter = window.location
): ProjectUrlAdapter => ({
  read: (): AppUrlContext => {
    const parsed = parseAppPathFromPathname(
      location.pathname,
      location.hostname
    );
    if (parsed.isLegacyPath) {
      return {};
    }

    return {
      org: parsed.org,
      project: parsed.project,
    };
  },
  write: (context: AppUrlContext): void => {
    const { org, project } = context;
    if (!org || !project) {
      return;
    }

    const nextPathname = buildAppPath(
      org,
      project,
      location.pathname,
      location.hostname
    );
    const nextOrigin = getOrgSwitchOrigin(org, location.hostname);
    const pathUnchanged =
      normalizePathname(nextPathname) === normalizePathname(location.pathname);

    if (pathUnchanged && !nextOrigin) {
      return;
    }

    const nextUrl = new URL(location.href);
    nextUrl.pathname = nextPathname;
    if (nextOrigin) {
      const originUrl = new URL(nextOrigin);
      nextUrl.protocol = originUrl.protocol;
      nextUrl.host = originUrl.host;
    }
    location.assign(nextUrl.toString());
  },
});

export const infieldProjectUrlAdapter = createInfieldProjectUrlAdapter();
